import React, { useState, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './css/AddCaptain.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
// import captain_json from './js/captains.json'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios'
import { DBContext } from './DBContext'
 
function EditTax () {

    const api_base_url = process.env.REACT_APP_API_BASE_URL;

    const { logginedDB } = useContext(DBContext);

    const location = useLocation()

    // const [tax, setTax] = useState({})

    // const [taxGroups, setTaxGroups] = useState([]);    
    // const [sdate, setSdate] = useState("")
    // const [edate, setEdate] = useState("")
    //('tax', tax);
    // const api_base_url = process.env.REACT_APP_API_BASE_URL;
    // const { logginedDB } = useContext(DBContext);
    // const location = useLocation();
    const navigate = useNavigate();
    
    const taxData = location.state || {}; 
    const [taxGroups, setTaxGroups] = useState({});
    const [sdate, setSdate] = useState("");
    const [edate, setEdate] = useState("");

    const [tax, setTax] = useState({
        id: taxData.id || '',
        gName: taxData.tax || ''
    });

    const id_tax = tax.id;

    // const taxData = location.state || {}; // Default to an empty object if state is undefined

    // console.log("Received state:", taxData); // Debugging

    // const [tax, setTax] = useState({
    //     id: taxData.id || '',  // Use state values or default to empty strings
    //     gName: taxData.tax || ''
    // });

    // console.log("tax", taxGroups)

    // const id_tax = tax.id
    // useEffect(() => {
    //     if (location.state) {
    //         setUserDetails(location.state.userDetails)
    //         setUType(location.state.type)
    //     }
    // },[location])


    // const navigate = useNavigate(null)

    // const handGetTaxGroups = async () => {
    // useEffect(() => {
    //     try {
    //         const response = await fetch(`${api_base_url}/getTaxGroups/${logginedDB}/${id_tax}`, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //         const data = await response.json();
    //         setTaxGroups(data);
            
    //     } catch (error) {
    //         console.error('Error fetching items:', error);
    //     }
    // });

    useEffect(() => {
        const fetchTaxGroups = async () => {
            try {
                const response = await fetch(`${api_base_url}/getGroupByIdTax/${logginedDB}/${id_tax}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
    
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
    
                const data = await response.json();
                // console.log(data[0])
                setTaxGroups(data[0]);
                setSdate(formatForInput(data[0]?.sdate));
                setEdate(formatForInput(data[0]?.edate));
            } catch (error) {
                console.error('Error fetching tax groups:', error);
            }
        };
    
        fetchTaxGroups(); // Call the function
    
    }, [api_base_url, logginedDB, id_tax]); // ✅ Dependency array to prevent infinite loops
    
    const edatedb = taxGroups.edate
    const sdatedb = taxGroups.sdate

    // console.log(edatedb, sdatedb)

    // const formatDate = (isoDate) => {
    //     if (!isoDate) return ""; // Handle null or undefined
    //     const date = new Date(isoDate);
    //     return date.toLocaleDateString("en-GB"); // Converts to DD/MM/YYYY
    // };

    // const formatForDisplay = (dateString) => {
    //     if (!dateString) return "";
    //     const [year, month, day] = dateString.split("-");
    //     return `${day}-${month}-${year}`;
    // };

    // Convert DD-MM-YYYY to YYYY-MM-DD for input[type="date"]
    // const formatForInput = (dateString) => {
    //     if (!dateString) return "";
    //     const [day, month, year] = dateString.split("-");
    //     return `${day}-${month}-${year}`;
    // };
    // console.log(taxGroups)
    const formatForInput = (isoDate) => {
        if (!isoDate) return "";
        return new Date(isoDate).toISOString().split("T")[0];
    };

    useEffect(() => {
        if (taxGroups.sdate && taxGroups.edate) {
            setSdate((taxGroups.sdate.split('T')[0])); // Convert on load
            setEdate((taxGroups.edate.split('T')[0]));
        }
    }, [taxGroups]);

    const handleSdateChange = (e) => {
        const newDate = e.target.value; // YYYY-MM-DD
        // console.log(newDate, "newDate sdate")
        setSdate(newDate);  // Show as DD-MM-YYYY
    };

    const handleEdateChange = (e) => {
        const newDate = e.target.value; // YYYY-MM-DD
        // console.log(newDate, "newDate edate")
        setEdate(newDate);  // Show as DD-MM-YYYY
    };

    const handleSavebutton = async () => {
        if ( !taxGroups.cgst  || !taxGroups.name  ||
            !taxGroups.gstPercent
             || !taxGroups.sgst ) {
                console.log(taxGroups.cgst, taxGroups.gName, taxGroups.gstPercent,
                    taxGroups.sgst, "inside if"
                )
            return alert("Make sure all fields are filled")
        }
        // console.log(sdate, "s", edate, taxGroups.cgst, taxGroups.name, taxGroups.gstPercent, taxGroups.igst,
        //     taxGroups.sgst)
        if (!sdate || !edate || sdate >= edate) {
            return alert("Please Check Start date and End data")
        }
        console.log("everything correct")
        try {
            const payload = {
                ...taxGroups, // Spread the existing taxGroups data
                sdate,       // Add sdate to the body
                edate        // Add edate to the body
            };
            const response = await fetch(`${api_base_url}/editTax/${logginedDB}/${id_tax}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
            });

            if (response.status === 200) {
                //("200");
                
                toast.success(`Tax group updated successfully!`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
                navigate('/basemenureg', {
                    state: 'taxCancel'
                })
            } else if (response.status === 404) {
                //("409");
                
                toast.success(`Tax not found`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
            } else {
                toast.success(`Something went wrong. Please try again!!`, {
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => { }
                });
            }
        } catch (error) {
            toast.success(`Something went wrong. Please try again!!`, {
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => { }
            });
        }
    }
    const toNavigateback = () => {
        navigate('/basemenureg', {
            state: 'taxCancel'
        })
    }

    // const handleTax = (e, field) => {
    //     const val = e.target.value
    //     setTax(prev => ({
    //         ...prev,
    //         [field]: val
    //     }))
    const handleTax = (e, field) => {
        const val = e.target.value;
        setTaxGroups(prev => ({
            ...prev,
            [field]: val
        }));
    };
    // } 
    // console.log(tax, "tax")
    return (
        <div className='TableRegMainDiv'>
            <SherDineNav />
            <div className='w-full bg-[#f5f5f5] flex gap-3 h-full'>
                <div className='w-max h-full z-[9999]'>
                    <SideNav focus={'User'} />
                </div>
                <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3'>
                    <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                        <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Taxes'} />
                    </div>
                    <div className='w-full h-full flex flex-col gap-3 relative'>
                        <div className='w-full h-max flex bg-[#fff] p-2 text-[1rem] font-nunito'>
                            <span className='w-1/2 font-[600] flex justify-start items-center'>Edit Tax Group</span>
                            <div className='w-1/2 font-[500] flex justify-end items-center gap-3'>
                                <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none' onClick={toNavigateback}>Cancel</button>
                                <button className='bg-[#0008B4] text-[#fff] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none' onClick={handleSavebutton}>Save</button>
                            </div>
                        </div>
                        <div className='bg-[#fff] p-3 h-full flex flex-col gap-3' id="contentContainer">
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>Tax Group Name</span>
                                    <input type="text" value={taxGroups.name} onChange={(e) => handleTax(e, 'name')} />
                                    {/* <input type="text" value={taxGroups.name} onChange={(e) => handleTax(e, 'name', 'gName')} /> */}
                                </div>
                                <div className='Reg_input_div'>
                                    <span>GST %</span>
                                    <input type="number" value={taxGroups.gstPercent} onChange={(e) => handleTax(e, 'gstPercent')} />
                                    {/* <input type="number" value={taxGroups.gstPercent} onChange={(e) => handleTax(e, 'gstPercent' ,'gstPercent')} /> */}
                                </div>
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>SGST</span>
                                    <input type="number" value={taxGroups.sgst} onChange={(e) => handleTax(e, 'sgst')} />
                                    {/* <input type="number" value={taxGroups.sgst} onChange={(e) => handleTax(e, 'sgst')} /> */}
                                </div>
                                <div className='Reg_input_div'>
                                    <span>CGST</span>
                                    <input type="number" value={taxGroups.cgst} onChange={(e) => handleTax(e, 'cgst')} />
                                    {/* <input type="number" value={taxGroups.cgst} onChange={(e) => handleTax(e, 'cgst')} /> */}
                                </div>
                                {/* <div className='Reg_input_div'>
                                    <span>IGST</span>
                                    <input type="number" value={taxGroups.igst} onChange={(e) => handleTax(e, 'igst')} />
                                    {/* <input type="number" value={taxGroups.igst} onChange={(e) => handleTax(e, 'igst')} /> * /}
                                </div> */}
                            </div>
                            <div className='flex gap-3'>
                                <div className='Reg_input_div'>
                                    <span>SDate</span>
                                    <input type="date" value={sdate} onChange={handleSdateChange} />
                                    {/* <small>Selected: {formatForDisplay(sdate)}</small> */}
                                </div>
                                <div className='Reg_input_div'>
                                    <span>EDate</span>
                                    <input type="date" value={edate} onChange={handleEdateChange} />
                                    {/* <small>Selected: {formatForDisplay(edate)}</small> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditTax
